import React from "react"
import { Container, Paper, Typography, Box, Link, Button } from "@mui/material"
import T from "../hooks/Language/T"
import { useApiService } from "../hooks/Api/useApiService"
import useError from "../hooks/Error/useError"

export default function TermsOfService() {
  const appName = "Sharie"
  const contactEmail = "wishgoods@gmail.com"
  const lastUpdated = "18/08/2025"

  const { postData } = useApiService()
  const { Error: ErrorAlert, success, error } = useError()

  const onAccept = () => {
    postData("users/terms", { user_name: localStorage.getItem("user") }).then((data) => {
      if (data.message === "Successful") success("Cookies accepted successfully!")
      else error("Failed to accept cookies. Please try again later.")
    })
  }

  return (
    <T>
      <Container maxWidth='md' sx={{ py: { xs: 3, md: 6 } }}>
        <Paper elevation={3} sx={{ p: { xs: 3, md: 5 }, borderRadius: 4 }}>
          <Box sx={{ direction: "rtl", textAlign: "right" }}>
            <Typography variant='h3' sx={{ fontWeight: 800, color: "primary.main", mb: 2 }}>
              {"תנאי שימוש - " + appName}
            </Typography>

            <Typography variant='subtitle1' sx={{ mb: 3, color: "text.secondary" }}>
              {"עודכן לאחרונה : " + lastUpdated}
            </Typography>

            <Typography variant='body1' paragraph>
              {"ברוכים הבאים ל־ " +
                appName +
                " אנו מודים לכם שבחרתם בנו. השימוש באתר ובשירותים שלנו כפוף לתנאים המפורטים במסמך זה. אנא קראו בעיון את תנאי השימוש לפני השימוש בפלטפורמה."}
            </Typography>

            <SectionTitle>א. קבלת התנאים</SectionTitle>
            <Typography variant='body1' paragraph>
              {"בשימושכם ב־" +
                appName +
                ", אתם מאשרים כי קראתם, הבנתם והסכמתם לתנאי השימוש הללו. אם אינכם מסכימים, אנא הימנעו משימוש בשירות."}
            </Typography>

            <SectionTitle>ב. שימוש מותר</SectionTitle>
            <Typography variant='body1' paragraph>
              אתם מתחייבים להשתמש בשירותים שלנו באופן חוקי בלבד, ובהתאם לכל דין, מבלי לפגוע, להפריע
              או לשבש את פעילות הפלטפורמה או המשתמשים האחרים.
            </Typography>

            <SectionTitle>ג. תוכן משתמש</SectionTitle>
            <Typography variant='body1' paragraph>
              {"כל תוכן שמועלה על ידכם ל־" +
                appName +
                " הינו באחריותכם הבלעדית. הנכם מצהירים כי יש בידיכם את כל הזכויות לפרסם תוכן זה, וכי הוא אינו מפר זכויות יוצרים או זכויות צד שלישי כלשהו."}
            </Typography>

            <SectionTitle>ד. הגבלת אחריות</SectionTitle>
            <Typography variant='body1' paragraph>
              {"ידוע לי כי " +
                appName +
                " מספקת את השירותים כפי שהם (AS IS) ואינה מתחייבת לזמינות רציפה או נטולת שגיאות. איננו אחראים לנזקים ישירים או עקיפים הנגרמים כתוצאה מהשימוש."}
            </Typography>

            <SectionTitle>ה. שינויים בתנאים</SectionTitle>
            <Typography variant='body1' paragraph>
              אנו שומרים לעצמנו את הזכות לשנות ולעדכן תנאים אלו מעת לעת. המשך השימוש בשירות לאחר
              שינוי ייחשב כהסכמה לגרסה המעודכנת.
            </Typography>

            <SectionTitle>ו. יצירת קשר</SectionTitle>
            <Typography variant='body1' sx={{ mb: 1.5 }}>
              לשאלות, בירורים או מימוש זכויותיכם, ניתן לפנות אלינו בכתובת:
              <Link href={`mailto:${contactEmail}`} underline='hover' color='secondary'>
                {contactEmail}
              </Link>
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Button variant='contained' color='primary' onClick={onAccept}>
              קיבלתי
            </Button>
          </Box>
          <ErrorAlert />
        </Paper>
      </Container>
    </T>
  )
}

function SectionTitle({ children }) {
  return (
    <Typography variant='h5' sx={{ mt: 3, mb: 1.5, fontWeight: 800, color: "primary.main" }}>
      {children}
    </Typography>
  )
}
